import React from 'react';

import reduxStore from '../../../reduxStore';
import { POPUP_LIFETIME } from '../../../constants';
import xhr from '../../../utils/xhr';
import utils from '../../../utils/utilities';

import editActions from '../../../api/EditThirdParty.api';
import popupActions from '../../../reusable/MessagePopup/redux/MessagePopup.actions';

import Spinnable from '../../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';

import EditName from './EditName';
import EditEntityId from './EditEntityId';
import EditEntityDuns from './EditEntityDuns';
import EditEntityExperian from './EditEntityExperian';
import EditEntityUrl from './EditEntityUrl';
import EditActivation from './EditActivation';
import EditCategories from './EditCategories';

class AboutEntityPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {companyData: null};

        this.updateCompanyData = this.updateCompanyData.bind(this);
        this.toggleEntityActivation = this.toggleEntityActivation.bind(this);
    }

    componentWillMount() {

        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState({companyData: reduxStore.getState().editThirdParty.companyData});
            }
        );
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    updateCompanyData(property, value, popupMessage) {
        let data = Object.assign({}, reduxStore.getState().editThirdParty.companyData);
        data[property] = value;
        this.props.spinner.showSpinner();
        editActions
            .saveCompanyData(data)
            .then((companyData) => {
                reduxStore.dispatch({type: 'LOAD_COMPANY_DATA', payload:companyData});
                this.props.spinner.hideSpinner();
                popupMessage ? this.showSuccessPopup(popupMessage) : null;
            })
            .catch((error) => {
                if (error.status === 400) {
                    this.showErrorPopup();
                    this.reloadCompanyData(data);
                } else {
                    xhr.handleAllErrors(error);
                    this.props.spinner.hideSpinner();
                }
                utils.logError(error, 'EditThirdParty.actions.updateCompanyData(): ');
            });
    }

    toggleEntityActivation(property, value, popupMessage) {
        let data = Object.assign({}, reduxStore.getState().editThirdParty.companyData);
        data[property] = value;
        this.props.spinner.showSpinner();
        editActions.toggleEntityActivation(data)
            .then((companyData) => {
                reduxStore.dispatch({type: 'LOAD_COMPANY_DATA', payload:companyData});
                this.props.spinner.hideSpinner();
                popupMessage ? this.showSuccessPopup(popupMessage) : null;
            })
            .catch((error) => {
                if (error.status === 400) {
                    this.showErrorPopup();
                    this.reloadCompanyData(data);
                } else {
                    xhr.handleAllErrors(error);
                    this.props.spinner.hideSpinner();
                }
                utils.logError(error, 'EditThirdParty.actions.updateCompanyData(): ');
            });
    }

    reloadCompanyData(data) {
        editActions
            .loadCompanyData(data.id)
            .then((companyData) => {
                reduxStore.dispatch({type: 'LOAD_COMPANY_DATA', payload: companyData});
                this.props.spinner.hideSpinner();
            })
            .catch((error) => {
                xhr.handleAllErrors(error);
                this.props.spinner.hideSpinner();
            });
    }

    showErrorPopup() {
        // Show error message of popup can not be shown.
        popupActions.setMessages({
            popupTitle: null,
            messages: [
                {
                    messageId: 'General_CoreFunctionality_Error_general.saveError',
                    messageType: 'system-error'
                }
            ]
        });

        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }

    showSuccessPopup(message) {
        // Show received success message.
        popupActions.setMessages({
            popupTitle: null,
            messages: [
                {
                    messageId: message,
                    messageType: 'success'
                }
            ]
        });
        // Hide the message after 5 seconds.
        setTimeout(popupActions.removeMessage, POPUP_LIFETIME);
    }


    render() {

        return (
            <form className='edit-third-party__about__form'>
                <div className='edit-third-party__about__container'>
                    <div className="edit-third-party__about__left">
                        {this.state.companyData ? <EditName entityId={this.state.companyData.id}
                                                            companyTitle={this.state.companyData.companyTitle}
                                                            dunsNumber={this.state.companyData.dunsNumber}
                                                            onBlur={this.updateCompanyData}/> : null}
                        {this.state.companyData ? <EditEntityId uniqueThirdPartyId={this.state.companyData.uniqueThirdPartyId} onBlur={this.updateCompanyData}/> : null}
                        {this.state.companyData ? <EditEntityDuns dunsNumber={this.state.companyData.dunsNumber} onBlur={this.updateCompanyData}/> : null}
                        {this.state.companyData ? <EditEntityExperian experianBusinessId={this.state.companyData.experianBusinessId} entityId={this.state.companyData.id} entityName={this.state.companyData.companyTitle} onBlur={this.updateCompanyData}/> : null}
                    </div>

                    <div className="edit-third-party__about__right">
                        {this.state.companyData ? <EditEntityUrl entityUrl={this.state.companyData.entityUrl} onBlur={this.updateCompanyData}/> : null}
                        {this.state.companyData ? <EditCategories data={this.state.companyData.categoryIds} handleChange={this.updateCompanyData} companyId={this.state.companyData.id} companyTitle={this.state.companyData.companyTitle} /> : null}
                        {this.state.companyData ? <EditActivation data={this.state.companyData.active} handleChange={this.toggleEntityActivation} enableDeactivateWarning={true}/> : null}
                    </div>
                </div>
            </form>
        );

    }

}

export default Spinnable(AboutEntityPanel);


// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/AboutEntityPanel.jsx